import { ChannelChatInformationScreenNavigationProps } from "./types"
import React from "react"
import ChannelChatInformation from "./channel-chat-information-screen"
import { PageRoot } from "~screens/page-root"


const ChannelChatInformationScreen: React.FC<ChannelChatInformationScreenNavigationProps> = (props) => {
  return (
    <PageRoot>
      <ChannelChatInformation {...props}/>
    </PageRoot>
  )
}

export default ChannelChatInformationScreen
